<style src="./ReportCredit.scss" lang="scss"></style>
<template>
  <div class="wrapper wrapper-content">
    <div class="mail-box-header">
      <form class="form-horizontal" @submit.prevent="filterReport">
        <div class="row">
          <div class="col-lg-4">
            <div class="row">
              <div class="col-sm-12">
                <div class="form-group">
                  <label class="col-sm-12">Colaborador</label>
                  <select class="form-control m-b" v-model="form.employee">
                    <option
                      v-for="(item, idx) in employeeList"
                      :key="idx"
                      :value="item.id"
                    >
                      {{ item.fullName }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-4">
            <div class="col-sm-12">
              <div class="form-group">
                <label class="col-sm-12">Veículo</label>
                <div class="col-sm-12">
                  <input
                    type="text"
                    placeholder="ABC-1234"
                    class="form-control"
                    v-model="form.licencePlate"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-4">
            <div class="col-sm-12">
              <div class="form-group">
                <label class="col-sm-12">Data</label>
                <div class="col-sm-12">
                  <input
                    type="date"
                    placeholder="30/12/2019"
                    class="form-control"
                    v-model="startDate"
                  />
                </div>
              </div>
            </div>

            <!-- <div class="col-sm-6">
              <div class="form-group">
                <label class="col-sm-12">Data final</label>
                <div class="col-sm-12">
                  <input
                    type="date"
                    placeholder="30/12/2019"
                    class="form-control"
                    v-model="endDate"
                  />
                </div>
              </div>
            </div>

            <div class="col-sm-6">
              <div class="form-group">
                <label class="col-sm-12">Hora Inicial</label>
                <div class="col-sm-12">
                  <input
                    type="time"
                    placeholder="09:00:00"
                    class="form-control"
                    v-model="startTime"
                  />
                </div>
              </div>
            </div>

            <div class="col-sm-6">
              <div class="form-group">
                <label class="col-sm-12">Hora Final</label>
                <div class="col-sm-12">
                  <input
                    type="time"
                    placeholder="15:00:00"
                    class="form-control"
                    v-model="endTime"
                  />
                </div>
              </div>
            </div> -->
          </div>
        </div>
        <div class="row">
          <div class="col-sm-2">
            <button
              class="btn btn-lg btn-primary"
              type="submit"
              :disabled="allowSearch || isLoading"
            >
              <i v-show="!isLoading" class="fa fa-search"></i>
              <i v-show="isLoading" class="fa-spin fa fa-spinner"></i>
              Buscar
            </button>
          </div>

          <!-- <div class="col-sm-2">
            <button
              class="btn btn-lg btn-primary"
              type="button"
              @click="downloadCSV"
            >
              <i class="fa fa-search"></i>
              Baixar CSV
            </button>
          </div> -->
        </div>
      </form>
    </div>

    <spinner v-if="showSpinner" />

    <div class="ibox-content">
      <!-- <div class="alert alert-success">
        Foram encontrados {{ countPages }} registro{{ countPages > 1 ? 's' : '' }}
      </div>-->
      <div class="alert alert-success" v-show="totalAmountPaid">
        Valor Total:
        <strong>R$ {{ totalToCurrencyBR(totalAmountPaid) }}</strong>
      </div>
    </div>

    <div class="mail-box">
      <table class="table table-hover table-mail">
        <thead>
          <tr>
            <th>Placa</th>
            <th>Colaborador</th>
            <th>Estacionamento</th>
            <th>Código</th>
            <th>Data</th>
            <th v-if="hasPermissionToDisplayHours">Hora</th>
            <th>Valor</th>
            <th>Minutos</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item, idx) in resultList"
            :key="idx"
            :class="{ unread: item.settled }"
          >
            <td>{{ item.licencePlate }}</td>
            <td>{{ item.employeeName }}</td>
            <td>{{ item.parkName }}</td>
            <td>{{ item.creditCode }}</td>
            <td>{{ fillDate(item.startDate) }}</td>
            <td v-if="hasPermissionToDisplayHours">
              {{ fillTime(item.startDate) }}
            </td>
            <td>{{ totalToCurrencyBR(item.settledAmountPaid) }}</td>
            <td>{{ item.totalMinutes }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="btn-group paginatecontent" v-if="countPages > 0">
      <button
        class="btn btn-light btn-sm paginatebutton"
        :disabled="hasPageLeft"
        @click="previousPage"
      >
        <i class="fa fa-arrow-left" />
      </button>

      <button
        class="btn btn-light btn-sm paginatebutton"
        :disabled="hasPageRight"
        @click="nextPage"
      >
        <i class="fa fa-arrow-right" />
      </button>
    </div>
  </div>
</template>

<script>
import Spinner from '@/components/Spinner';

export default {
  components: { Spinner },
  data() {
    return {
      showSpinner: false,
      form: {
        employee: '',
        licencePlate: '',
        pageSkip: 0,
        pageLimit: 30,
        showSettled: true,
        showNotSettled: true,
      },
      startDate: '',
      endDate: '',
      startTime: '',
      endTime: '',
      totalAmountPaid: null,
      countPages: 0,
      employeeList: [],
      resultList: [],
      isLoading: false,
    };
  },
  computed: {
    hasPageLeft() {
      return this.form.pageSkip === 0;
    },
    hasPageRight() {
      return this.form.pageSkip + this.form.pageLimit >= this.countPages;
    },
    hasPermissionToDisplayHours() {
      return this.$store.getters['DATA-ACCESS/HasAccess'](
        'report-credit-display-hours',
        'SHOW',
      );
    },
    allowSearch() {
      return !(
        (this.form.employee.length > 0 || this.form.licencePlate.length > 6) &&
        this.startDate.length > 0
      );
    },
  },
  mounted() {
    this.listEmployee();
    const dt = new Date();
    this.startDate = `${dt.getFullYear()}-${('0' + (dt.getMonth() + 1)).slice(
      -2,
    )}-${('0' + dt.getDate()).slice(-2)}`;
    this.endDate = `${dt.getFullYear()}-${('0' + (dt.getMonth() + 1)).slice(
      -2,
    )}-${('0' + dt.getDate()).slice(-2)}`;
    this.endTime = '23:59:00';
    this.startTime = '00:00:00';
  },
  methods: {
    fillDate(value) {
      return new Date(value).toLocaleDateString('pt-BR');
    },
    fillTime(value) {
      return new Date(value).toLocaleTimeString('pt-BR');
    },
    totalToCurrencyBR(value) {
      if (!value) {
        return '-';
      }
      // return (value / 100).toFixed(2).toString().replace('.', ',');
      return (value / 100).toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
      });
    },
    async listEmployee() {
      const employeeListFull = await this.$store.dispatch(
        'EMPLOYEE/GetEmployeeList',
      );
      const employeeList = employeeListFull
        .map(item => ({
          id: item._id,
          fullName: item.fullName,
          userType: item.userType,
        }))
        .filter(item => item.userType !== 'qrpix');
      this.employeeList = employeeList;
    },
    generateQuery() {
      const query = {
        ...this.form,
      };
      // const sD = this.startDate.split('-');
      // console.log(sD);
      // const startDate = new Date(sD[0], sD[1] - 1, sD[2], 0, 0, 0);
      // const endDate = new Date(sD[0], sD[1] - 1, sD[2], 20, 59, 59);

      // query.startDate = startDate;
      // query.endDate = endDate;
      query.startDate = new Date(`${this.startDate}T00:00:01`);
      query.endDate = new Date(`${this.startDate}T23:59:59`);

      return query;
    },
    // async downloadCSV() {
    //   const query = this.generateQuery();
    //   try {
    //     const response = await this.$store.dispatch(
    //       'REPORTS/DownloadCreditCSV',
    //       {
    //         query,
    //       },
    //     );

    //     const url = window.URL.createObjectURL(new Blob([response]));
    //     const link = document.createElement('a');
    //     link.href = url;
    //     link.setAttribute('download', 'RELATORIO DE CREDITOS.csv');
    //     document.body.appendChild(link);
    //     link.click();
    //   } catch (error) {
    //     this.resultList = [];
    //     this.showSpinner = false;
    //   }
    // },
    async filterReport() {
      this.isLoading = true;
      this.showSpinner = true;
      this.totalAmountPaid = null;
      const query = this.generateQuery();

      try {
        const reports = await this.$store.dispatch('REPORTS/ReportCredit', {
          query,
        });
        if (!(reports.list && reports.list.length > 0)) {
          this.resultList = [];
          this.showSpinner = false;
          this.isLoading = false;
          return true;
        }
        this.pageSkip = 0;
        this.countPages = reports.countTotal.count;
        const resultList = reports.list.map(item => {
          const licencePlate = item.vehicle
            ? item.vehicle.licencePlate.toUpperCase()
            : '';
          const amountPaid = item.amountPaid;
          const creditCode = item.creditCode;
          const settledAmountPaid = item.settledAmountPaid;
          const totalMinutes = item.totalMinutes;
          const settled = item.settled;
          const parkName = item.parks ? item.parks.parkName : '-';
          const notification = item.notification
            ? item.notification.notifyCode
            : '-';
          let employeeName = '';
          let startDate = '';
          if (item.settled) {
            if (item.settledEmployee && item.settledEmployee) {
              employeeName =
                item.settledEmployee && item.settledEmployee.fullName;
            } else {
              employeeName = 'CLIENTE';
            }
            startDate = item.paymentDate;
          } else {
            employeeName = item.employee && item.employee.fullName;
            startDate = item.createdAt;
          }
          return {
            licencePlate,
            creditCode,
            amountPaid,
            settledAmountPaid,
            totalMinutes,
            employeeName,
            parkName,
            startDate,
            settled,
            notification,
          };
        });
        this.totalAmountPaid = reports.countTotal.totalPaid;
        this.resultList = resultList;
        this.showSpinner = false;
        this.isLoading = false;
      } catch (error) {
        this.resultList = [];
        this.showSpinner = false;
        this.isLoading = false;
      }
    },
    nextPage() {
      if (this.form.pageSkip + this.form.pageLimit > this.countPages) {
        return;
      }
      this.form.pageSkip = this.form.pageSkip + this.form.pageLimit;

      this.filterReport();
    },
    previousPage() {
      if (this.form.pageSkip === 0) {
        return;
      }
      this.form.pageSkip = this.form.pageSkip - this.form.pageLimit;

      this.filterReport();
    },
  },
};
</script>
